import { useEffect, useState, useContext } from "react";
import style from './Grades.module.css';

import Lottie from 'lottie-react';
import marks_animation from '../../../lottieAnimations/marks_animation.json';
import icons from "../../../icons";

import { AppContext } from "../../../AppContext";

import { Swiper, SwiperSlide } from 'swiper/react';
// import SwiperCore, { EffectFlip, Autoplay  } from 'swiper';
import 'swiper/swiper-bundle.css';
import Banner from "../../Banner/Banner";
import { useRef } from "react";
import { deleteField, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { buildStyles, CircularProgressbar, CircularProgressbarWithChildren } from "react-circular-progressbar";
import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";
import { Reorder } from "framer-motion";


// SwiperCore.use([ EffectFlip, Autoplay ]);


const literalGrades = [
    "0", "0+", "0½", "1-",
    "1", "1+", "1½", "2-",
    "2", "2+", "2½", "3-",
    "3", "3+", "3½", "4-",
    "4", "4+", "4½", "5-",
    "5", "5+", "5½", "6-",
    "6", "6+", "6½", "7-",
    "7", "7+", "7½", "8-",
    "8", "8+", "8½", "9-",
    "9", "9+", "9½", "10-",
    "10", "10+"
];

const numericGrades = [
    0, 0.3, 0.5, 0.8,
    1, 1.3, 1.5, 1.8,
    2, 2.3, 2.5, 2.8,
    3, 3.3, 3.5, 3.8,
    4, 4.3, 4.5, 4.8,
    5, 5.3, 5.5, 5.8,
    6, 6.3, 6.5, 6.8,
    7, 7.3, 7.5, 7.8,
    8, 8.3, 8.5, 8.8,
    9, 9.3, 9.5, 9.8,
    10, 10

];

const getLiteralGrade = numericGrade => {
    if (typeof numericGrade == 'undefined') return "";
    return literalGrades[numericGrades.indexOf(numericGrade)];
};

const getItalianEventType = (type) => {
    switch(type) {
        case "homework":
            return "Compito per casa";
        case "interrogation":
            return "Interrogazione";
        case "test":
            return "Verifica";
        case "other":
            return "Altro";
        default:
            return "";
    }
};

let sectionsTouchInterval;

const Grades = props => {
    const { setPage: setGlobalPage, data, user, setUser, subjects, tests, interrogations, homeworks, others, sectionsOrder, updateSectionOrder: setSectionsOrder, editingSectionsOrder, setEditingSectionsOrder } = useContext(AppContext);

    const getSubjectIcon = subjectName => {
        let returnIcon = "question_mark_icon";
        if (typeof subjectName == 'undefined') return returnIcon;
        Object.values(subjects).forEach(subject => {
            if (subject.subject.toLowerCase() === subjectName.toLowerCase()) returnIcon = subject.icon;
        });
        return returnIcon;
    };

    const [showSubjectsGrades, setShowSubjectsGrades] = useState({});
    const [activeSlide, setActiveSlide] = useState(undefined);
    const [swiper, setSwiper] = useState(undefined);
    const [termsGrades, setTermsGrades] = useState([{}, {}]);
    const [globalGradesAverages, setGlobalGradesAverages] = useState({ 0: 0, 1: 0 });
    const [currentTerm, setCurrentTerm] = useState(0);
    const [averages, setAverages] = useState([]);
    const [grades, setGrades] = useState([]);
    const [gradeGoal, setGradeGoal] = useState(user?.gradeGoal)
    const [showGradeGoalPicker, setShowGradeGoalPicker] = useState(false);

    const subjectAverages = [[], []];
    const tempTermsGrades = [{}, {}];

    const [page, setPage] = useState(0);
    const pageSwiper = useRef();

    const swipePage = index => {
        setPage(index);
        pageSwiper.current.swiper.slideTo(index);
    };

    useEffect(() => {
        if (data && Object.keys(data).length > 0 && typeof activeSlide == 'undefined') {
            const termsSeparatorDate = new Date(data.calendar?.termsSeparator) ?? new Date(2022, 0, 1);
            setCurrentTerm(Number(new Date().getTime() >= termsSeparatorDate.getTime()))
            setActiveSlide(Number(new Date().getTime() >= termsSeparatorDate.getTime()));
        }
    }, [data]);

    useEffect(() => {
        if (data && subjects) {
            const termsSeparatorDate = new Date(data.calendar?.termsSeparator) ?? new Date(2022, 0, 1);

            let tempAverageGrades = { 0: 0, 1: 0 }
            let newShowSubjectsGrades = {};
            Object.values(subjects).forEach(subject => {
                newShowSubjectsGrades[subject.subject] = false;
            });

            Object.values(subjects).forEach(subject => {
                tempTermsGrades[0][subject.subject] = {};
                tempTermsGrades[1][subject.subject] = {};
            });

            Object.values(tests ?? []).forEach(test => {
                if (typeof test.grades?.[user.id]?.grade != 'undefined') tempTermsGrades[Number(new Date(test.date).getTime() >= termsSeparatorDate.getTime())][test.subject][test.id] = test;
            });

            Object.values(interrogations ?? []).forEach(interrogation => {
                if (typeof interrogation.grades?.[user.id]?.grade != 'undefined') tempTermsGrades[Number(new Date(interrogation.startDate).getTime() >= termsSeparatorDate.getTime())][interrogation.subject][interrogation.id] = interrogation;
            });

            Object.values(homeworks ?? []).forEach(homework => {
                if (typeof homework.grades?.[user.id]?.grade != 'undefined') tempTermsGrades[Number(new Date(homework.date).getTime() >= termsSeparatorDate.getTime())][homework.subject][homework.id] = homework;
            });

            let newGrades = { ...tempTermsGrades }; 
            Object.entries(tempTermsGrades).forEach(([term, termGrades]) => {
                Object.entries(termGrades).forEach(([subjectName, subjectGrade]) => {
                    const eventsGrades = Object.values(subjectGrade).filter(({ grades }) => grades[user.id]?.inGradeAverage).map(({ grades }) => parseFloat(grades[user.id].grade));
                    if (eventsGrades.length > 0) {
                        subjectAverages[term].push(eventsGrades.reduce((total, grade) => total + grade) / eventsGrades.length);
                        newGrades[term][subjectName].averageGrade = eventsGrades.reduce((total, grade) => total + grade) / eventsGrades.length;
                    } 
                });

                if (subjectAverages[term].length > 0) 
                    tempAverageGrades[term] = Number(subjectAverages[term].reduce((total, grade) => total + grade) / subjectAverages[term].length).toFixed(1);
            });
            
            setGlobalGradesAverages(tempAverageGrades);
            setTermsGrades(newGrades);
            setShowSubjectsGrades(newShowSubjectsGrades);

            const getEvents = eventsType => Object.values(eventsType ?? []).sort((first, second) => new Date(first.date ?? first.startDate) - new Date(second.date ?? second.startDate));
            let gradesSum = 0, counter = 0, tempAverages = [], events = [...getEvents(tests), ...getEvents(interrogations), ...getEvents(homeworks), ...getEvents(others)];

            events.forEach(event => {
                if (event.grades?.[user?.id]?.grade != undefined && event.grades?.[user?.id].inGradeAverage && Number(new Date(event.startDate ?? event.date).getTime() >= termsSeparatorDate.getTime()) === currentTerm) {
                    gradesSum += parseFloat(event.grades?.[user?.id]?.grade);
                    counter += 1;
                    tempAverages.push(gradesSum / counter);
                }
            });

            setGrades(events.filter(event => event.grades?.[user?.id]?.grade != undefined && event.grades?.[user?.id].inGradeAverage && Number(new Date(event.startDate ?? event.date).getTime() >= termsSeparatorDate.getTime()) === currentTerm).map(event => event.grades?.[user?.id]?.grade))
            setAverages(tempAverages);
        }
    }, [data, subjects, tests, interrogations, homeworks, others, currentTerm]);

    useEffect(() => {
        setShowSubjectsGrades({});
    }, [activeSlide]);

    if (globalGradesAverages[0] > 0 || globalGradesAverages[1] > 0)
        return <main onClick={ () => setEditingSectionsOrder(false) }>
            <div className={ style.flex } style={{ marginLeft: "1rem" }}>
                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ () => setGlobalPage({ page: "home" }) }></img>
                <h1 style={{ fontSize: "1.75rem", marginLeft: ".5rem", color: "var(--orange)" }}>Voti</h1>
            </div>
            <main className={ style.main }>
                <Reorder.Group axis="x" values={ sectionsOrder.grades ?? [] } onReorder={ newOrder => {
                    localStorage.setItem("globalSectionsOrder", JSON.stringify({ ...sectionsOrder, grades: newOrder }))
                    setSectionsOrder({ grades: newOrder });
                } } style={{ listStyleType: "none", padding: "0", margin: "0" }}>
                    <section className={ style.pageChoices }>
                        { sectionsOrder.grades?.map((section, idx) => <Reorder.Item key={ section } value={ section } dragListener={ editingSectionsOrder }>        
                            <div className={ [style.pageChoice, page === idx && style.selected, editingSectionsOrder && style.editingSectionsOrder].join(" ") } onClick={ () => swipePage(idx) } onTouchStart={ e => {
                                sectionsTouchInterval = setInterval(() => setEditingSectionsOrder(true), 500)
                                e.stopPropagation();
                            } }  onTouchMove={ () => clearInterval(sectionsTouchInterval) } onTouchEnd={ () => clearInterval(sectionsTouchInterval) } >
                                <h4>{ section }</h4>
                            </div>
                        </Reorder.Item>) }
                    </section>
                </Reorder.Group>
                <Swiper ref={ pageSwiper } onSlideChange={ ({ activeIndex }) => setPage(activeIndex) }>
                { sectionsOrder.grades?.map(section => {
                    switch (section) {
                        case "Per materia":
                            return <SwiperSlide key={ section }>
                                <Banner id="ads" />
                                <section style={{ marginBottom: "2rem" }}>
                                    {/* <h3 className={ style.header }>I TUOI VOTI</h3> */}
                                    <Swiper direction="horizontal" initialSlide={ activeSlide ?? 0 } onSlideChange={ ({ activeIndex }) => setActiveSlide(activeIndex) } onSwiper={ swiper => setSwiper(swiper) }>
                                        { [0, 1].map(term => {
                                            return <SwiperSlide key={ term }>
                                                <div style={{ height: 150, width: 150, marginLeft: "auto", marginRight: "auto", display: "block", marginTop: "1.5rem", marginBottom: ".5rem" }}>    
                                                    <CircularProgressbarWithChildren
                                                        value={ globalGradesAverages[term] * 10 } 
                                                        strokeWidth={ 8 }
                                                        styles={ buildStyles({
                                                            pathColor: globalGradesAverages[term] >= 6 ? '#00e4136e' : globalGradesAverages[term] >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)",
                                                            trailColor: 'rgb(102, 101, 101)',
                                                            textColor: "white",
                                                        }) }>    
                                                            <h3 style={{ marginTop: "1rem", marginBottom: "0", fontSize: "1.5rem" }}>{ globalGradesAverages[term] }</h3>
                                                            <h4 style={{ marginTop: ".5rem", fontSize: ".9rem", textAlign: "center" }}>{term === 0 ? "PRIMO" : "SECONDO"}<br />PERIODO</h4>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            </SwiperSlide>; })
                                        }
                                    </Swiper>
                                    <div className={ style.pagination }>
                                        <span className={ activeSlide === 0 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => swiper.slideTo(0) }></span>
                                        <span className={ activeSlide === 1 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => swiper.slideTo(1) }></span>
                                        <span></span>
                                    </div>
                                </section>
                                <section style={{ overflowY: "scroll", height: "58vh" }} id="subjects-section">
                                    { Object.entries(termsGrades[activeSlide]).map(([subject, subjectGrades]) => {
                                        return <div key={ subject } className={ style.subject } style={{ marginBottom: showSubjectsGrades[subject] ? "2rem" : "0" }}>
                                            <div onClick={ () => {
                                                if (Object.values(subjectGrades).filter(subjectGrade => typeof subjectGrade != "number").length > 0)
                                                    setShowSubjectsGrades({ ...showSubjectsGrades, [subject]: !showSubjectsGrades[subject] });
                                            } }>
                                                <img src={ icons[getSubjectIcon(subject)] } className={ style.subjectIcon }></img>
                                                <h3>{ subject }</h3>
                                                <div className={ style.subjectDetails }>
                                                    <div style={{ marginTop: ".5rem", height: 60, width: 60 }}>
                                                        <CircularProgressbarWithChildren
                                                            value={ (subjectGrades.averageGrade ?? 0) * 10 } 
                                                            strokeWidth={ 8 }
                                                            styles={ buildStyles({
                                                                pathColor: subjectGrades.averageGrade >= 6 ? '#00e4136e' : subjectGrades.averageGrade >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)",
                                                                trailColor: 'rgb(102, 101, 101)',
                                                                textColor: "white",
                                                            }) }>    
                                                                <h5 style={{ marginTop: "7.5rem", marginBottom: "0", fontSize: "1.1rem" }}>{ typeof subjectGrades.averageGrade != 'undefined' ? Number(subjectGrades.averageGrade).toFixed(1) : ""  }</h5>
                                                        </CircularProgressbarWithChildren>
                                                    </div>
                                                </div>
                                            </div>
                                            { (Object.values(termsGrades[activeSlide]).indexOf(subjectGrades) === Object.values(termsGrades[activeSlide]).length - 1 && showSubjectsGrades[subject] || Object.values(termsGrades[activeSlide]).indexOf(subjectGrades) !== Object.values(termsGrades[activeSlide]).length - 1) && <div className={ style.subjectGrades } style={{ 
                                                display: "block", 
                                                height: showSubjectsGrades[subject] ? `${4 * Object.values(subjectGrades).filter(subjectGrade => typeof subjectGrade != "number").length}rem` : "0", 
                                                opacity: showSubjectsGrades[subject] ? "1" : "0" ,
                                                transition: showSubjectsGrades[subject] ? "height .25s ease, opacity 1s ease, margin .5s ease" : "height 1s ease, opacity .25s ease, margin .5s ease",
                                                marginBottom: showSubjectsGrades[subject] ? `${2 * Object.values(subjectGrades).filter(subjectGrade => typeof subjectGrade != "number").length}rem` : ""
                                            }} >
                                                { Object.values(subjectGrades).filter(subjectGrade => typeof subjectGrade != "number").sort((first, second) => new Date(first.date ?? first.startDate).getTime() - new Date(second.date ?? second.startDate).getTime()).map(subjectGrade => {
                                                    let grade = subjectGrade.grades?.[user.id];
                                                    let background;
                                                    let eventDate = new Date(subjectGrade.startDate ?? subjectGrade.date);

                                                    if (grade.inGradeAverage) {
                                                        if (grade?.grade >= 6) {
                                                            background = "rgb(0, 128, 0)";
                                                        } else if (grade?.grade >= 5.5) {
                                                            background = "rgb(255, 166, 0)";
                                                        } else {
                                                            background = "rgb(255, 0, 0)";
                                                        }
                                                    } else 
                                                        background = "rgb(0, 99, 248)";

                                                    return <div key={ subjectGrade.id } className={ style.subjectGrade } onClick={ () => setGlobalPage({ page: "add", event: subjectGrade }) }>
                                                        <h3 style={{ background }}>{ getLiteralGrade(parseFloat(subjectGrade.grades?.[user.id]?.grade)) }</h3> 
                                                        <div className={ style.gradeType }>
                                                            <img src={ icons[`${subjectGrade.type !== "homework" ? subjectGrade.type : "home_orange"}_icon`] }></img>
                                                            <h5>{ getItalianEventType(subjectGrade.type).toUpperCase() }</h5>
                                                        </div>
                                                        <h4>{ subjectGrade.title }</h4>
                                                        <h5 className={ style.evenDate }>{ eventDate.getDate() }/{ eventDate.getMonth() + 1 }</h5>
                                                    </div>
                                                }) }
                                            </div> }
                                        </div>
                                    }) }
                                </section>
                            </SwiperSlide>;
                        case "Statistiche":
                            return <SwiperSlide key={ section } onClick={ () => setShowGradeGoalPicker(false) }>
                                <h3 style={{ marginLeft: "1rem", marginBottom: "0", marginTop: "2rem" }}>Il tuo andamento</h3>
                                { grades.length > 1 ? <div style={{ marginLeft: "1rem", marginRight: "1rem", marginTop: "1rem", background: "rgb(50, 50, 50)", borderRadius: ".5rem", padding: "1rem .5rem" }}>
                                    <ResponsiveContainer height={ 200 }>
                                        <LineChart data={ averages.map((average, idx) => ({ average, grade: grades[idx], gradeGoal: numericGrades[literalGrades.indexOf(user?.gradeGoal)] })) }>
                                            <YAxis interval={ 0 }  axisLine={ false } tickLine={ false } tickMargin={ 20 } tick={{ fontWeight: "bold" }} domain={[ user?.gradesGoal ? Math.min(...grades, user?.gradeGoal) : Math.min(...grades), user?.gradesGoal ? Math.max(...grades, user?.gradeGoal) : Math.max(...grades) ]} />
                                            <Line type="monotone" dataKey="average" strokeWidth={ 3 } stroke={ averages.at(-1) >= 6 ? "rgb(0, 128, 0)" : averages.at(-1) >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)" } />
                                            <Line type="monotone" dataKey="grade" strokeWidth={ 3 } stroke="#d86c07" />
                                            <Line type="monotone" dataKey="gradeGoal" strokeDasharray="3 3" strokeWidth={ 3 } stroke="rgb(150, 150, 150)" />
                                        </LineChart>
                                    </ResponsiveContainer>
                                    <div className={ style.gradesLegend }>
                                        <h5 style={{ backgroundColor: averages.at(-1) >= 6 ? "rgb(0, 128, 0)" : averages.at(-1) >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)" }}>MEDIA</h5>
                                        <h5>VOTI</h5>
                                        <h5 style={{ backgroundColor: "rgb(150, 150, 150)" }}>OBIETTIVO</h5>
                                    </div>
                                </div> : <div style={{ marginLeft: "1rem", marginRight: "1rem", marginTop: "1rem", background: "rgb(50, 50, 50)", borderRadius: ".5rem", padding: "1rem .5rem" }}>
                                    <h4 style={{ marginLeft: "1rem", marginRight: "1rem" }}>Non ci sono ancora abbastanza voti per tracciare un grafico!</h4>
                                    <Lottie 
                                        style={{ marginTop: "1rem", width: "75vw", marginLeft: "auto", marginRight: "auto"}}
                                        loop={ false }
                                        autoplay={ true }
                                        animationData={ marks_animation }
                                        speed={ 0.1 }
                                        delay={ 5000 }
                                        rendererSettings={{
                                            preserveAspectRatio: "xMidYMid slice"
                                        }}
                                        height={ 200 }
                                        width={ 200 }
                                    />
                                </div> }
                                <div className={ style.flex } style={{ marginLeft: "1rem", marginRight: "1rem", marginTop: "1rem", background: "rgb(50, 50, 50)", borderRadius: ".5rem", paddingLeft: ".5rem", paddingRight: ".5rem" }} onClick={ e => {
                                    e.stopPropagation();
                                    setShowGradeGoalPicker(oldShowGradeGoalPicker => !oldShowGradeGoalPicker);
                                } }>
                                    <div style={{ flex: "1" }}>
                                        <h4 style={{ marginLeft: "1rem", marginBottom: "0", color: "var(--orange)" }}>Il tuo obiettivo</h4>
                                        <h5 style={{ marginLeft: "1rem", marginTop: ".5rem", marginRight: "2rem", marginBottom: "0" }}>{ user.gradeGoal ? (globalGradesAverages[currentTerm] >= numericGrades[literalGrades.indexOf(user.gradeGoal)] ? `Obiettivo raggiunto! Hai uno scarto di ${Number(globalGradesAverages[currentTerm] - numericGrades[literalGrades.indexOf(user.gradeGoal)]).toFixed(2)} punti` : `Sei di ${Number(numericGrades[literalGrades.indexOf(user.gradeGoal)] - globalGradesAverages[currentTerm]).toFixed(2)} punti sotto la media!`) : "Imposta il tuo obiettivo" }</h5>
                                        <div data-affectnavonscroll="false" className={ style.picker } style={{ width: "30vw", height: showGradeGoalPicker && "50%" }} onClick={ e => e.stopPropagation() }>
                                            { [ ...literalGrades ].reverse().map(option => <div key={ `goalGrade-${option}` } className={ [style.pickerOption, gradeGoal === option && style.selected].join(" ") } onClick={ async () => {
                                                setGradeGoal(option);
                                                setUser(oldUser => ({ ...oldUser, gradeGoal: option }));
                                                await updateDoc(doc(db, `users/${user.id}`), { gradeGoal: option });
                                            } }><h3>{ option }</h3></div>) }
                                        </div> 
                                        <h5 style={{ fontSize: ".8rem", marginLeft: "1rem", textDecoration: "underline", color: "gray", marginTop: ".75rem", marginBottom: ".75rem", width: "fit-content" }} onClick={ async e => {
                                            e.stopPropagation();
                                            setGradeGoal(null);
                                            setUser(oldUser => ({ ...oldUser, gradeGoal: null })); 
                                            await updateDoc(doc(db, `users/${user.id}`), { gradeGoal: deleteField() });
                                        } }>Cancella obiettivo</h5>
                                    </div>
                                    <h3 style={{ marginRight: "1.5rem", fontSize: "2rem", color: globalGradesAverages[currentTerm] >= numericGrades[literalGrades.indexOf(user.gradeGoal)]  ? "rgb(0, 128, 0)" : "rgb(150, 150, 150)", marginTop: "auto", marginBottom: "auto" }}>{ user.gradeGoal ?? "?" }</h3>
                                </div>
                            </SwiperSlide>;
                        }
                    }) }
                </Swiper>
            </main>
        </main>;

    return <>
        <div className={ style.flex } style={{ marginLeft: "1rem" }}>
            <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ () => setGlobalPage({ page: "home" }) }></img>
            <h1 style={{ fontSize: "1.75rem", marginLeft: ".5rem", color: "var(--orange)" }}>Voti</h1>
        </div>
        <main className={ style.main }>
            <Banner />
            <h3 className={ style.header }>Ancora nessun voto!</h3>
            <Lottie 
                style={{ marginTop: "1rem" }}
                loop={ false }
                autoplay={ true }
                animationData={ marks_animation }
                speed={ 0.1 }
                delay={ 5000 }
                rendererSettings={{
                    preserveAspectRatio: "xMidYMid slice"
                }}
                height={ 300 }
                width={ 300 }
            />
            <h4 className={ style.subHeader }>Clicca su un evento per segnare il tuo voto</h4>
        </main>
    </>;
};

export default Grades;